export default __webpack_public_path__ + "static/media/services-img.c87ecc35.png";